import CpfValidate from './rules/cpf'
export default function (value, args) {
  return CpfValidate(value)
}